import { useFetchDocument } from "../../../hooks/useGetDocument";
import { Autocomplete, TextField } from "@mui/material";

export const DocumentAutocomplete = ({
  token,
  documentID,
  setDocumentID,
  assignedDocuments = [],
}) => {
  const { document, loading } = useFetchDocument(token);

  const assignedDocumentIds = assignedDocuments.map((doc) => doc.ID_DOCUMENTO);

  const documentOptions = document.map((doc) => ({
    id: doc.ID_DOCUMENTO,
    label: doc.NOMBRE_DOCUMENTO,
    disabled: assignedDocumentIds.includes(doc.ID_DOCUMENTO),
  }));

  const selectedDocument = documentID
    ? documentOptions.find((doc) => doc.id === documentID.id) || null
    : null;

  const handleSelectionChange = (event, value) => {
    if (value && !value.disabled) {
      setDocumentID(value);
    } else {
      setDocumentID(null);
    }
  };

  return (
    <Autocomplete
      disablePortal
      options={documentOptions}
      getOptionLabel={(option) => option.label || ""}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      loading={loading}
      value={selectedDocument}
      onChange={handleSelectionChange}
      getOptionDisabled={(option) => option.disabled}
      renderOption={(props, option) => (
        <li
          {...props}
          key={option.id}
          style={{
            ...(option.disabled
              ? {
                  color: "#aaaaaa",
                  textDecoration: "line-through",
                  cursor: "not-allowed",
                }
              : {}),
          }}
        >
          {option.label} {option.disabled && " (ya asignado)"}
        </li>
      )}
      renderInput={(params) => (
        <TextField {...params} label="Buscar documento" />
      )}
    />
  );
};
